import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { event } from '../../../store/selectors/event';
import { createEvent } from '../../../store/actions/event';

const withClone = Component => {
  const Composed = ({ event, createEvent, ...props }) => {
    const clonedEvent = { ...event, dateTime: null };
    return (
      <Component
        {...props}
        title="Clone event"
        saveButtonTitle="Clone"
        event={clonedEvent}
        action={createEvent}
      />
    );
  };

  const mapStateToProps = state => ({
    event: event(state),
  });

  Composed.propTypes = {
    event: PropTypes.shape({}),
    createEvent: PropTypes.func.isRequired,
  };

  Composed.defaultProps = {
    event: null,
  };

  return connect(mapStateToProps, { createEvent })(Composed);
};

export default withClone;
